import React from 'react';

export const Cell = ({ children }: any) => <span style={{ fontSize: '12px' }}>{children}</span>
